import ManagePortfoliosModal from './ManagePortfoliosModal';

export default ManagePortfoliosModal;
